module.exports = __webpack_public_path__ + "static/media/Original Korean - Teaching - nolyuk.35fc69bc.txt";